



































































import { defineComponent } from '@vue/composition-api'

import { AppToggleButton } from '@/components/atoms'
import { SpecialOfferReceiptEntity } from '../../../../api/@types'
import { DelyNgReason } from '@/types/special-offer'

type Props = {
  specialOfferReceipt: SpecialOfferReceiptEntity
}

export default defineComponent({
  name: 'SpecialOfferReceiptActions',
  components: { AppToggleButton },
  props: {
    specialOfferReceipt: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const toggleError = (newNgReason: DelyNgReason) => {
      let ngReason: null | DelyNgReason = newNgReason
      if (props.specialOfferReceipt.ngReason === newNgReason) {
        ngReason = null
      }
      const newSpecialOfferReceipt = {
        ...props.specialOfferReceipt,
        ngReason,
      }
      context.emit('update:specialOfferReceipt', newSpecialOfferReceipt)
    }

    return {
      toggleError,
      DelyNgReason,
    }
  },
})
